import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { connect } from 'react-redux';
import { setBreadcrumbItems } from '../../store/actions';

const Descuentos = (props) => {
  document.title = 'Descuentos | Listado - Ges Sindical';

  const breadcrumbItems = [
    { title: 'Descuentos', link: '#' },
    { title: 'Listado', link: '#' },
  ];

  useEffect(() => {
    props.setBreadcrumbItems('Descuentos', breadcrumbItems);
    fetchDescuentos();
  }, []);

  const [descuentos, setDescuentos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [editando, setEditando] = useState(null);
  const [nombre, setNombre] = useState('');
  const [descripcion, setDescripcion] = useState('');
  const [porcentaje, setPorcentaje] = useState('');
  const [tipo, setTipo] = useState('permanente');
  const [maxMeses, setMaxMeses] = useState('');
  const [hermanos, setHermanos] = useState('');
  const [activo, setActivo] = useState(true);

  const fetchDescuentos = () => {
    setLoading(true);
    fetch('https://asijeminapis.website:5248/api/discounts')
      .then(res => res.json())
      .then(data => {
        setDescuentos(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  const abrirFormNueva = () => {
    setEditando(null);
    setNombre('');
    setDescripcion('');
    setPorcentaje('');
    setTipo('permanente');
    setMaxMeses('');
    setHermanos('');
    setActivo(true);
    setShowForm(true);
  };

  const abrirFormEditar = (d) => {
    setEditando(d._id);
    setNombre(d.name);
    setDescripcion(d.description || '');
    setPorcentaje(d.percentage);
    setTipo(d.type);
    setMaxMeses(d.conditions?.maxMonths || '');
    setHermanos(d.conditions?.siblings || '');
    setActivo(d.isActive !== false);
    setShowForm(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!nombre || isNaN(Number(porcentaje))) {
      Swal.fire({ icon: 'warning', title: 'Complete todos los campos correctamente.' });
      return;
    }
    setLoading(true);
    const body = {
      name: nombre,
      description: descripcion,
      percentage: Number(porcentaje),
      type: tipo,
      conditions: {
        maxMonths: tipo === 'temporal' ? Number(maxMeses) : undefined,
        siblings: hermanos ? Number(hermanos) : undefined
      },
      isActive: activo
    };

    const method = editando ? 'PUT' : 'POST';
    const url = editando ? `https://asijeminapis.website:5248/api/discounts/${editando}` : 'https://asijeminapis.website:5248/api/discounts';

    try {
      const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      if (res.ok) {
        Swal.fire({ icon: 'success', title: editando ? 'Descuento actualizado.' : 'Descuento creado.' });
        setShowForm(false);
        fetchDescuentos();
      } else {
        Swal.fire({ icon: 'error', title: 'Error al guardar descuento.' });
      }
    } catch {
      Swal.fire({ icon: 'error', title: 'Error de red.' });
    }
    setLoading(false);
  };

  const toggleEstado = (desc) => {
    Swal.fire({
      title: desc.isActive ? '¿Desactivar descuento?' : '¿Activar descuento?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: desc.isActive ? 'Desactivar' : 'Activar'
    }).then(async result => {
      if (result.isConfirmed) {
        try {
          await fetch(`https://asijeminapis.website:5248/api/discounts/${desc._id}/status`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ isActive: !desc.isActive })
          });
          fetchDescuentos();
        } catch {
          Swal.fire({ icon: 'error', title: 'Error al cambiar estado.' });
        }
      }
    });
  };

  return (
    <div className="container mt-4">
      <h2>Descuentos</h2>
      <button className="btn btn-success mb-3" onClick={abrirFormNueva}>+ Nuevo Descuento</button>

      {loading && <p>Cargando...</p>}

      {!loading && descuentos.length > 0 && (
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Porcentaje</th>
              <th>Tipo</th>
              <th>Activo</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {descuentos.map(d => (
              <tr key={d._id} style={{ opacity: d.isActive ? 1 : 0.5 }}>
                <td>{d.name}</td>
                <td>{d.percentage}%</td>
                <td>{d.type}</td>
                <td>{d.isActive ? 'Sí' : 'No'}</td>
                <td>
                  <button className="btn btn-sm btn-primary me-2" onClick={() => abrirFormEditar(d)}>Editar</button>
                  <button className="btn btn-sm btn-warning" onClick={() => toggleEstado(d)}>
                    {d.isActive ? 'Desactivar' : 'Activar'}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {showForm && (
        <div className="modal show" style={{ display: 'block', background: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <form className="modal-content" onSubmit={handleSubmit}>
              <div className="modal-header">
                <h5 className="modal-title">{editando ? 'Editar Descuento' : 'Nuevo Descuento'}</h5>
                <button type="button" className="btn-close" onClick={() => setShowForm(false)}></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label>Nombre</label>
                  <input type="text" className="form-control" value={nombre} onChange={e => setNombre(e.target.value)} required />
                </div>
                <div className="mb-3">
                  <label>Descripción</label>
                  <input type="text" className="form-control" value={descripcion} onChange={e => setDescripcion(e.target.value)} />
                </div>
                <div className="mb-3">
                  <label>Porcentaje</label>
                  <input type="number" className="form-control" value={porcentaje} onChange={e => setPorcentaje(e.target.value)} required />
                </div>
                <div className="mb-3">
                  <label>Tipo</label>
                  <select className="form-control" value={tipo} onChange={e => setTipo(e.target.value)}>
                    <option value="temporal">Temporal</option>
                    <option value="permanente">Permanente</option>
                  </select>
                </div>
                {tipo === 'temporal' && (
                  <div className="mb-3">
                    <label>Máx. Meses</label>
                    <input type="number" className="form-control" value={maxMeses} onChange={e => setMaxMeses(e.target.value)} />
                  </div>
                )}
                
                <div className="mb-3">
                  <label>
                    <input type="checkbox" checked={activo} onChange={e => setActivo(e.target.checked)} /> {' '}
                    Descuento activo
                  </label>
                </div>
              </div>
              <div className="modal-footer">
                <button type="submit" className="btn btn-primary">{editando ? 'Actualizar' : 'Crear'}</button>
                <button type="button" className="btn btn-secondary" onClick={() => setShowForm(false)}>Cancelar</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {!loading && descuentos.length === 0 && <p>No hay descuentos registrados.</p>}
    </div>
  );
};

export default connect(null, { setBreadcrumbItems })(Descuentos);
